import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Bus from 'vue-bus'

import '@/assets/styles/index.scss'
import '@/plugins/element-ui'
import '@/assets/styles/iconfont.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  Bus,
  render: h => h(App)
}).$mount('#app')
